import BaseModule from './BaseModule.js';

class PixCashIns extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`back-office/pix_cash_ins`, { params: { page, per_page, term } });
  }

  async fetch(id) {
    return await this.get(`back-office/pix_cash_ins/${id}`);
  }

  async refund(id, reason) {
    return await this.post(`/back-office/pix_cash_ins/${id}/refund`, { reason });
  }
}

export default PixCashIns;
